import React from "react";
import { RuleCategorised } from "components/icons/RuleCategorised";
import { AICategorised } from "components/icons/AICategorised";
import { AICategorisedAccepted } from "components/icons/AICategorisedAccepted";
import Modal from "components/DesignSystem/Modal/Modal";
import { ModalProps } from "types/utils/modal";
import { LinkInvoice } from "components/icons/LinkInvoice";
import { AICategorisedBySystem } from "components/icons/AICategorisedBySystem";
import { AICategorisedManually } from "components/icons/AICategorisedManually";
import { BrexCategorised } from "components/icons/BrexCategorised";

const Item = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => {
  return (
    <div className="t-flex t-gap-3 t-p-3 t-border-solid t-border t-border-neutral-0 t-rounded">
      <div className="t-flex-shrink-0">{icon}</div>

      <div className="t-flex t-flex-col t-gap-1">
        <div className="t-text-subtitle-sm t-text-text-60">{title}</div>
        <div className="t-text-body-sm t-text-text-30">{description}</div>
      </div>
    </div>
  );
};

export const CategorisationStatusInfo = ({ isOpen, close }: ModalProps) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>Categorisation Status</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body className="t-flex t-flex-col t-gap-3">
          <Item
            icon={<AICategorised size="32" />}
            title="Categorised by AI Agent"
            description="Category suggested by AI Agent. Click to confirm & thus finalise."
          />

          <Item
            icon={<AICategorisedAccepted size="32" />}
            title="Categorised by AI Agent & Manually Confirmed"
            description="Category suggested by AI Agent & confirmed by user."
          />

          <Item
            icon={<LinkInvoice size="32" />}
            title="Linked to Inkle Invoices or Bills"
            description="Categorisation derived from linked invoices or bills. Accounting handled 
accordingly for both Cash and Accrual reports."
          />

          <Item
            icon={<RuleCategorised size="32" />}
            title="Categorised by Rules"
            description="Categorised automatically based on user-defined rules. 
No confirmation needed."
          />

          <Item
            icon={<AICategorisedBySystem size="32" />}
            title="Categorised by System"
            description="Categorised & handled automatically by the system for payment
processor transactions (e.g. Stripe). Read-only to ensure accuracy."
          />

          <Item
            icon={<BrexCategorised size="32" />}
            title="Categorised through Brex"
            description="Categorised through General Ledger accounts set on Brex."
          />

          <Item
            icon={<AICategorisedManually />}
            title="Categorised Manually"
            description="Categorised directly by user, including splits."
          />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
